__webpack_require__.p = "https://cdn.assets.salla.network/prod/@salla.sa/fast-checkout/v0.0.39/";